/**
 * 未ログインの会員候補でもアクセスでき、401 でもログイン画面へ飛ばしてはいけない公開パス。
 *
 * この一覧は複数箇所（httpDao の 401 リダイレクト抑止・
 * layout-wrapper の /me スキップ）で参照される。リストが分散すると
 * 「一部だけ許可され残りでログインに飛ぶ」不具合になるため、ここに集約する。
 */
export const PUBLIC_NO_REDIRECT_PREFIXES = [
  ...(import.meta.env.DEV ? ["/dev"] : []),
  "/join",
  "/invite/accept",
  "/family/invite/accept",
  "/staff/invite/accept",
  "/new-password",
  "/parent/new-password",
  "/account/register",
  "/account/verify-email",
  "/verify-code",
  "/terms",
  "/privacy",
  "/trial",
  "/embed",
  "/survey",
  "/events/cancel",
  "/payment/register",
  "/payment/tuition-migration",
];

/**
 * `/events/:id/apply` は中間セグメントが動的なため前方一致で表現できず、
 * かつ `/events/:id`（管理画面のイベント詳細）は認証必須なので
 * `/events` 全体を公開扱いにはできない。
 */
const PUBLIC_EVENT_APPLY_PATTERN = /^\/events\/[^/]+\/apply(?:[/?]|$)/;

/**
 * 公開の決済導線（申込＋決済ページ／決済リンクのお支払いページ）か。
 * サイドバー等の認証前提のレイアウトを描画しない判定にも使う。
 */
export const isPublicEventPaymentPath = (pathname: string): boolean =>
  pathname === "/events/payment" ||
  pathname.startsWith("/events/payment/") ||
  pathname.startsWith("/events/payment?") ||
  PUBLIC_EVENT_APPLY_PATTERN.test(pathname);

const matchesPublicPrefix = (pathname: string): boolean =>
  PUBLIC_NO_REDIRECT_PREFIXES.some(
    (p) =>
      pathname === p ||
      pathname.startsWith(`${p}/`) ||
      pathname.startsWith(`${p}?`)
  ) || isPublicEventPaymentPath(pathname);

/** 401 時にログイン画面へ飛ばすべきでないパスか（ルート `/` も含む・httpDao 用）。 */
export const isPublicNoRedirectPath = (pathname: string): boolean =>
  pathname === "/" || matchesPublicPrefix(pathname);

/** 未ログインでもアクセスできる公開ページか（ルート `/` は含めない・認証チェック用）。 */
export const isPublicPage = (pathname: string): boolean =>
  matchesPublicPrefix(pathname);
